import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Input, Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { userResetPassword } from "../../store/auth/forgetpwd/actions";
import { toast } from "react-toastify";

const ResetPassword = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const [formValues, setFormValues] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!token) {
      toast.error("Invalid reset link");
      navigate("/login");
    }
  }, [token, navigate]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { newPassword, confirmPassword } = formValues;

    if (!newPassword || !confirmPassword) {
      toast.error("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    setIsSubmitting(true);

    dispatch(
      userResetPassword(
        {
          token,
          newPassword,
        },
        navigate
      )
    );
  };

  return (
    <div className="bg-pattern" style={{ minHeight: "100vh" }}>
      <div className="account-pages d-flex align-items-center" style={{ minHeight: "100vh" }}>
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card className="shadow-lg">
                <CardBody className="p-4">

                  <h4 className="text-center mb-2">Reset Password</h4>

                  <form onSubmit={handleSubmit}>

                    <FormGroup>
                      <Label>New Password</Label>
                      <Input
                        type="password"
                        id="newPassword"
                        onChange={handleChange}
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Confirm Password</Label>
                      <Input
                        type="password"
                        id="confirmPassword"
                        onChange={handleChange}
                      />
                    </FormGroup>

                    <div className="d-grid mt-3">
                      <Button color="primary" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? "Updating..." : "Reset Password"}
                      </Button>
                    </div>

                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ResetPassword;